import React from "react";
import * as MUI from "@mui/material";
import { TABLE_CELL_ALIGNMENT } from "../enums/UserTableHeaderColumns";
import { useTranslation } from "react-i18next";

export default function TableRowHead({
  header,
  orderBy,
  order,
  createSortHandler,
  testIdPrefix,
}) {
  const { t } = useTranslation();
  return (
    <MUI.TableHead>
      <MUI.TableRow>
        {header.map((item, index) => (
          <MUI.TableCell
            sortDirection={orderBy === item.id ? order : false}
            align={TABLE_CELL_ALIGNMENT}
            key={item.id}
            sx={{ pl: 5, minWidth: 200 }}
          >
            <MUI.TableSortLabel
              active={orderBy === item.id}
              direction={orderBy === item.id ? order : "asc"}
              onClick={createSortHandler(item.id)}
              data-testid={testIdPrefix && `${testIdPrefix}.column.${item.id}.sort-button`}
            >
              {t(item.label)}
              {orderBy === item.id ? (
                <MUI.Box component="span" sx={{ display: "none" }}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </MUI.Box>
              ) : null}
            </MUI.TableSortLabel>
          </MUI.TableCell>
        ))}
      </MUI.TableRow>
    </MUI.TableHead>
  );
}
